import React from 'react';
import { ArrowRight, Mic2 } from 'lucide-react';

const FirstSongWelcome = ({ color, onGuided, onStandard }) => (
  <section className="mx-auto max-w-5xl py-8 sm:py-14" style={{ '--glow': color }}>
    <div className="max-w-3xl">
      <span
        className="flex h-14 w-14 items-center justify-center rounded-full"
        style={{ color, backgroundColor: `${color}1f` }}
      >
        <Mic2 className="h-7 w-7" />
      </span>
      <h1 className="mt-6 font-heading text-4xl font-black sm:text-6xl">
        Your first song starts here.
      </h1>
      <p className="mt-4 max-w-2xl text-lg leading-relaxed text-white/65">
        Pizzul walks you through it in 5 steps. Beat, flow, hook, verse, done.
        Takes about 15 minutes.
      </p>
    </div>

    <div className="mt-8 grid gap-3 sm:grid-cols-2">
      <button
        type="button"
        onClick={onGuided}
        className="neon-card flex min-h-36 items-end justify-between rounded-[1.75rem] border
          border-[color:var(--glow)] bg-white/[0.06] p-5 text-left"
      >
        <span>
          <span className="block font-heading text-2xl font-black">Walk me through it</span>
          <span className="mt-2 block text-base font-bold text-white/60">
            Start with a feel and build one part at a time.
          </span>
        </span>
        <ArrowRight className="h-6 w-6 shrink-0" style={{ color }} />
      </button>
      <button
        type="button"
        onClick={onStandard}
        className="flex min-h-36 items-end rounded-[1.75rem] border border-white/15 p-5
          text-left hover:border-white/35 hover:bg-white/[0.04]"
      >
        <span>
          <span className="block font-heading text-2xl font-black">I know what I'm doing</span>
          <span className="mt-2 block text-base font-bold text-white/50">
            Go straight to the regular Booth setup.
          </span>
        </span>
      </button>
    </div>
  </section>
);

export default FirstSongWelcome;
